<template>
  <div class="bet-dice-market" :class="{ 'bet-dice-market--triple': showTriple }">
    <template v-if="showTriple">
      <div
        v-for="group in marketGroups"
        :key="group.label"
        class="bet-dice-market__group"
      >
        <div class="bet-dice-market__faces bet-dice-market__faces--pair">
          <button
            v-for="face in group.faces"
            :key="face"
            type="button"
            class="bet-dice-market__face"
            :class="{
              'bet-dice-market__face--selected': draftBets[`single-${face}`],
              'bet-dice-market__face--result-matched': matchedFaces.includes(face),
            }"
            :aria-label="`Single ${face}`"
            @click="$emit('bet', `single-${face}`)"
          >
            <img :src="diceImage(face)" alt="" />
            <BetPlacedChip
              v-if="draftBets[`single-${face}`]"
              :amount="draftBets[`single-${face}`]"
              :chips="chips"
              placement="top-right"
              overlap
            />
          </button>
        </div>
        <div class="bet-dice-market__label">{{ group.label }}</div>
      </div>
    </template>

    <template v-else>
      <div class="bet-dice-market__compact">
        <div class="bet-dice-market__faces bet-dice-market__faces--full-row">
          <button
            v-for="face in dieFaces"
            :key="face"
            type="button"
            class="bet-dice-market__face"
            :class="{
              'bet-dice-market__face--selected': draftBets[`single-${face}`],
              'bet-dice-market__face--result-matched': matchedFaces.includes(face),
            }"
            :aria-label="`Single ${face}`"
            @click="$emit('bet', `single-${face}`)"
          >
            <img :src="diceImage(face)" alt="" />
            <BetPlacedChip
              v-if="draftBets[`single-${face}`]"
              :amount="draftBets[`single-${face}`]"
              :chips="chips"
              placement="top-right"
              overlap
            />
          </button>
        </div>
        <div class="bet-dice-market__labels">
          <span>SINGLE {{ singleOdds }}</span>
          <span>DOUBLE {{ doubleOdds }}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import BetPlacedChip from '@/components/tai-xiu/bet-placed-chip.vue';

export default {
  components: {
    BetPlacedChip,
  },
  props: {
    draftBets: {
      type: Object,
      required: true,
    },
    chips: {
      type: Array,
      default: () => [],
    },
    showTriple: {
      type: Boolean,
      default: false,
    },
    dieFaces: {
      type: Array,
      default: () => [1, 2, 3, 4, 5, 6],
    },
    matchedFaces: {
      type: Array,
      default: () => [],
    },
    singleOdds: {
      type: String,
      default: '1 : 0.97',
    },
    doubleOdds: {
      type: String,
      default: '1 : 1.94',
    },
    tripleOdds: {
      type: String,
      default: '1 : 2.91',
    },
  },
  computed: {
    marketGroups() {
      const labels = [
        `SINGLE ${this.singleOdds}`,
        `DOUBLE ${this.doubleOdds}`,
        `TRIPLE ${this.tripleOdds}`,
      ];
      const facesPerGroup = 2;
      const groups = [];

      for (let i = 0; i < labels.length; i += 1) {
        const start = i * facesPerGroup;
        groups.push({
          label: labels[i],
          faces: this.dieFaces.slice(start, start + facesPerGroup),
        });
      }

      return groups;
    },
  },
  methods: {
    diceImage(face) {
      return require(`@/assets/svg/dice-items/dice-${face}.svg`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixins/_tx-result-border.scss';

.bet-dice-market {
  &--triple {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.bet-dice-market__compact {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 4px;
}

.bet-dice-market__group {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 4px;
}

.bet-dice-market__faces {
  display: grid;

  &--full-row {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  &--pair {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.bet-dice-market__face {
  position: relative;
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  min-height: 30px;
  padding: 2px;
  border: 1px solid #253233;
  border-radius: 0;
  background: #161E1F;
  cursor: pointer;

  &:first-child {
    border-bottom-left-radius: 5px;
  }

  &:last-child {
    border-bottom-right-radius: 5px;
  }

  img {
    width: 20px;
    height: 20px;
    display: block;
  }

  &--selected {
    border-color: rgba(193, 170, 206, 0.4);
    background: linear-gradient(to bottom, #613f64, rgba(104, 81, 124, 0.4));
  }
}

.bet-dice-market__face--result-matched {
  @include tx-result-matched-border;
}

.bet-dice-market__faces--full-row .bet-dice-market__face {
  &:nth-child(1){
    border-bottom-left-radius: 5px;
  }

  &:nth-child(6) {
    border-bottom-right-radius: 5px;
  }

  // &:nth-child(2),
  // &:nth-child(5) {
  //   border-top-left-radius: 0;
  //   border-top-right-radius: 0;
  // }
}

.bet-dice-market__label {
  height: 20px;
  min-height: 20px;
  padding: 0 4px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ad94ad;
  background: rgba(157, 110, 124, 0.3);
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  border-radius: 0;
}

.bet-dice-market__group:first-child .bet-dice-market__label {
  border-bottom-left-radius: 6px;
}

.bet-dice-market__group:last-child .bet-dice-market__label {
  border-bottom-right-radius: 6px;
}

.bet-dice-market__labels {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px;

  span {
    height: 20px;
    min-height: 20px;
    padding: 0 4px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ad94ad;
    background: rgba(157, 110, 124, 0.3);
    font-size: 10px;
    font-weight: 800;
    line-height: 1;
    text-align: center;
    white-space: nowrap;

    &:first-child {
      border-bottom-left-radius: 6px;
    }

    &:last-child {
      border-bottom-right-radius: 6px;
    }
  }
}
</style>
